const DataCdcgovLinks = () => {
    return (
        <div id="csv-links">
            <a id="national-csv" className="csv-link" href="https://data.cdc.gov/Injury-Violence/Mapping-Injury-Overdose-and-Violence-National/t6u2-f84c/about_data" target="_blank">
                Download National Data
            </a>
            <a id="state-csv" className="csv-link" href="https://data.cdc.gov/Injury-Violence/Mapping-Injury-Overdose-and-Violence-State/fpsi-y8tj/about_data" target="_blank">
                Download State Data
            </a>
            <a id="county-csv" className="csv-link" href="https://data.cdc.gov/Injury-Violence/Mapping-Injury-Overdose-and-Violence-County/psx4-wq38/about_data" target="_blank">
                Download County Data
            </a>
            <a id="census-csv" className="csv-link" href="https://data.cdc.gov/Injury-Violence/Mapping-Injury-Overdose-and-Violence-Census-Tract/4day-mt2f/about_data" target="_blank">
                Download Census Tract Data
            </a>
        </div>
    );
};
export default DataCdcgovLinks;
